import {
  warningColor,
  primaryColor,
  dangerColor,
  successColor,
  infoColor,
  roseColor,
  grayColor,
  blackColor,
  defaultFont,
  hexToRgb
} from "assets/jss/emjayTheme.js";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";
import customDropdownStyle from "./customDropdownStyle";

const tableStyle = theme => ({
  ...customCheckboxRadioSwitch,
  ...customDropdownStyle(theme),
  warning: {
    color: warningColor[0]
  },
  primary: {
    color: primaryColor[0]
  },
  danger: {
    color: dangerColor[0]
  },
  success: {
    color: successColor[0]
  },
  info: {
    color: infoColor[0]
  },
  rose: {
    color: roseColor[0]
  },
  gray: {
    color: grayColor[0]
  },
  right: {
    textAlign: "right"
  },
  noPadding: {
    padding: "0 !important"
  },
  table: {
    marginBottom: "0",
    width: "100%",
    maxWidth: "100%",
    backgroundColor: "transparent",
    borderSpacing: "0",
    borderCollapse: "collapse",
    overflow: "auto"
  },
  tableShoppingHead: {
    fontSize: "0.9em !important",
    textTransform: "uppercase !important"
  },
  tableHeadFontSize: {
    fontSize: '10px',
    fontWeight: 400,
    color:  grayColor[2],
  },
  tableHeadCell: {
    backgroundColor: grayColor[4],
    border: "none !important",
  },
  tableCell: {
    ...defaultFont,
    lineHeight: "1.42857143",
    padding: "12px 8px!important",
    verticalAlign: "middle",
    fontSize: "1em",
    borderBottom: "none",
    borderTop: "1px solid " + grayColor[5],
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      minHeight: "24px",
      minWidth: "32px"
    },
    "& img": {
      height: '50px'
    }
  },
  tableCellTotal: {
    fontWeight: "500",
    fontSize: "1.25em",
    paddingTop: "14px",
    textAlign: "right"
  },
  tableCellAmount: {
    fontSize: "26px",
    fontWeight: "300",
    marginTop: "5px",
    textAlign: "right"
  },
  tableResponsive: {
    // width: "100%",
    minHeight: "0.1%",
    overflow: "visible"
  },
  tableStripedRow: {
    backgroundColor: grayColor[12]
  },
  tableRow: {
    position: 'relative'
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: grayColor[13]
    }
  },
  warningRow: {
    backgroundColor: warningColor[6],
    "&:hover": {
      backgroundColor: warningColor[5]
    }
  },
  dangerRow: {
    backgroundColor: dangerColor[6],
    "&:hover": {
      backgroundColor: dangerColor[5]
    }
  },
  successRow: {
    backgroundColor: successColor[6],
    "&:hover": {
      backgroundColor: successColor[5]
    }
  },
  infoRow: {
    backgroundColor: infoColor[6],
    "&:hover": {
      backgroundColor: infoColor[5]
    }
  },
  tableRowBody: {
    height: "48px"
  },
  tableRowHead: {
    height: "56px"
  },

  pointer: {
    cursor: "pointer",
  },
  overlayContainer: {
    backgroundColor: 'transparent',
    position: "fixed",
    top: "min(50%, 50vh)",
    transform: "translateY(calc(-50%))",
  },
  overlayRoot: {
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  stockPill:{
    width: '88px',
    height: '30px'
  },
  addItemWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    width: '140px',
    color: 'orangered',
    cursor: 'pointer',
    justifyContent: 'flex-start',
    "& > svg": {
      marginLeft: '5px'
    }
  },
  saveButton: {
    // padding: '16px 0',
    fontWeight: 500,
    fontSize: "14px",
  },
  details: {
    display: "flex",
  },
  rightContainer: {
    flex: 1,
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    padding: 35,
    width: 300,
  },
  container: {
    paddingBottom: "75px!important",
    overflowY: "auto",
    padding: "20px"
  },
});

export default tableStyle;
